import { Component, inject } from '@angular/core';
import { InfoService } from '../../shared/services/info.service';

@Component({
    selector: 'ldw-messages-page',
    templateUrl: './messages-page.component.html',
    styleUrls: ['./messages-page.component.css'],
    standalone: false
})
export class MessagesPageComponent {
  private infoService = inject(InfoService);

  constructor() {
    this.infoService.clearStatus();
  }
}
